<template>
  <div class="busMonitoring">
    <div class="busMonitoringList">
      <div class="busMonitoringList__header">
        <div class="busMonitoringList__header__left">
          <div class="busMonitoringList__header__left__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
        </div>
        <!-- <div class="busMonitoringList__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
        </div> -->
      </div>
    </div>
    <adx-table text="Tooltip button"
      :loading.sync= "isLoading"
      :items.sync="data"
      :isEmpty.sync="isEmpty"
      @selectedAction="selectedAction"
      @downloadBast="downloadBast">
    </adx-table>
    <div class="range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Campaigns</div>
    <adx-pagination
      v-if="!isLoading && !isEmpty"
      :max-page="maxPage"
      :selected-page="selectedPage"
      @change-page="selectPage"
    />
  </div>
</template>

<script>
  import Loading from '@/components/Loading/Primary'
  import Pagination from '@/components/Pagination'
  import DropdownSort from '@/components/Form/SelectDropdown'
  import table from '@/components/Table'
  import {helpers} from '@/lib/validation/'
  import api from '@/api'
  import { apiV2 } from '@/api/urls'

  export default {
  name: 'adx-measurement-bus',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
    'adx-table': table,
  },
  props: {

  },
  data() {
    return {
      result: [],
      retryCount: 0,
      isLoading: true,
      searchBoxValue:'',
      selectedPage: 1,
      currentPage: 1,
      next: 0,
      count: 0,
      page: 1,
      maxPage: 1,
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "CHANNEL",
            type: "text"
          },
          {
            title: "PERIOD",
            type: "period"
          },
          {
            title: "STATUS",
            type: "statuslabel"
          },
          {
            title: "",
            type: "button"
          },
          {
            title: "",
            type: "icon"
          }
        ],
        body : []
      },
    }
  },
  computed: {
    isEmpty: function(){
      return !(this.data.body && this.data.body.length)
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count >15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
    getFilterParams: function () {
      return {
        search: this.searchBoxValue || undefined
      }
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1;
        this.count = 0;
        this.initalLoad()
       
      })
    }, 300),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.selectedPage = parseInt(page)
    }
    this.initalLoad()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async initalLoad(){
      this.isLoading = true
      let params = {
        ...this.getFilterParams
      };
      const result = await  this.$apollo.query({
        query:require('@/graphql/bus/query/busOrdersPage.gql'),
        variables:{
            search: this.searchBoxValue.toString() || undefined,
            page: this.selectedPage.toString() || "1",
        },
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy: 'network-only', 
      })
      if (result.data){
        if (result.errors){
          // this.handleError(data.errors)
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: `Something went wrong. Please refresh the page!`,
            type: 'danger'
          });
        } else{
          const { busOrdersPage } = await result.data
          if (busOrdersPage) {
            await this.mapData(busOrdersPage)
          }
        }
        this.isLoading = false
      }
    },
    async mapData(busOrdersPage){
      let meta = busOrdersPage.meta
      let result = busOrdersPage.busOrders
      this.resetData()
      let body = []
      await result.forEach(res => {
        let campaignStatus = {}
        if (res.campaign.status != null && res.campaign.statusDisplay !=null){
          campaignStatus = this.getCampaignStat(res.campaign.statusDisplay)
        }
        let valuesData = [
          { value: res.id},
          { value: res.campaign.title},
          { value: "Transit"},
          { start: res.campaign.start, end:res.campaign.end},
          { value: campaignStatus, label: campaignStatus.toUpperCase()},
          { value: true, 
            disabled: res.bast.length > 0 ? false : true, 
            label:"Latest BAST",
            icon: true,
            tooltip: 'Download BAST'
            },
          { icon: "icon-eye", text: "View Detail"}
        ];
        body.push({
          id: res.id,
          values:valuesData,
          bast: res.bast
        });
      });
      this.data.body = body
      this.count = meta.count
      this.maxPage = meta.maxPage
      this.isLoading = false
    },
    resetData(){
      this.data.body = null
      this.data.body = []
    },
    selectedAction(id, type, item){
      let campaign = item.values[1].value;
      if(type === 'icon-eye'){
        this.$router.push({name: 'monitoringbusdetail', params: { id: item.id, campaign: campaign }})
      }else{
        // this.downloadBast()
      }
    },
    async selectPage(item) {
      this.selectedPage = item;
      this.initalLoad()
    },
    downloadBast(index, value, item){
      let urlBast = item.bast.pop().content_url
       this.$http.get(urlBast, {
        responseType: 'arraybuffer',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET',
            // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        })
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/ptestdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = urlBast.split('/').pop()
        link.click()
      })
    },
    getCampaignStat(stat){
      let status = "canceled"
      switch (stat) {
        case `Draft`:
          status = "draft"
          break;
        case `Verifying`:
          status = "verifying"
          break;
        case `Active`:
          status = "active"
          break;
        case `Cancel`:
          status = "canceled"
          break;
        case `Expired`:
          status = "expired"
          break;
        case `Deleted`:
          status = "deleted"
          break;
        case `Dormant`:
          status = "dormant"
          break;
        case `Upcoming`:
          status = "upcoming"
          break;       
      }
      return status
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .busMonitoring{
    .table table tbody tr td .text{
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 200px;
      min-width: 50px;
    }
  }
</style>